import React, { useEffect, useRef, useState } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useParams } from 'react-router-dom';
import logo from "../assets/images.png";
import Api from "../api/Api";
import formatarValor from '../formatarValor';
import dayjs from "dayjs";
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';


const toBase64 = (url) =>
  fetch(url)
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );

const RelatorioProdutosVendidos = () => {
  const { dataInicio, dataFim } = useParams();
  const [produtos, setProdutos] = useState([]);
  const [empresa, setEmpresa] = useState(null);
  const [loading, setLoading] = useState(true);
  const pdfRef = useRef();
  const [iframeHeight, setIframeHeight] = useState("500px");

 // const BASE_IMAGE_URL = 'http://127.0.0.1:8000/img/';
   const BASE_IMAGE_URL = 'https://qrorder.technext.ao/public/img/';

  useEffect(() => {
    fetchData();
  }, []);

      useEffect(() => {
     document.title = "Produtos Vendidos";
   
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      // Buscar produtos vendidos
      const produtosData = await Api.ListProdutoVendido({
        dataInicio,
        dataFim
      });
      setProdutos(produtosData);

      // Buscar dados da empresa
      const empresaData = await Api.ListEmpresa();
      if (empresaData) {
        const emp = Array.isArray(empresaData) ? empresaData[0] : empresaData;
        setEmpresa({
          ...emp,
          img: emp.img ? (emp.img.startsWith("http") ? emp.img : `${BASE_IMAGE_URL}${emp.img}`) : null
        });
      }

    } catch (error) {
      console.error("Erro ao carregar dados:", error);
    } finally {
      setLoading(false);
    }
  };

  const getCurrentDateTime = () => {
    const now = new Date();
    const date = now.toLocaleDateString("pt-BR");
    const time = now.toLocaleTimeString("pt-BR");
    return `${date} ${time}`;
  };

  const generatePDF = async (companyLogo) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    const data = produtos.map(p => [
      p.numero,
      dayjs(p.dataemissao).format("DD/MM/YYYY"),
      p.produto,
      formatarValor(Number(p.preco)),
      p.quantidade,
      formatarValor(Number(p.total))
    ]);

    const totalGeral = produtos.reduce((sum, p) => sum + Number(p.total || 0), 0);

    // Cabeçalho
    if (companyLogo) {
      doc.addImage(companyLogo, "PNG", 10, 10, 30, 30);
    }
    if (empresa) {
      doc.setFontSize(8);
      doc.text(empresa.nome || "Empresa não cadastrada", 45, 15);
      doc.text(`NIF: ${empresa.nif || "N/A"}`, 45, 20);
      doc.text(empresa.endereco || "Endereço não informado", 45, 25);
      doc.text(`Telefone: ${empresa.telefone || "N/A"}`, 45, 30);
      doc.text(`Email: ${empresa.email || "N/A"}`, 45, 35);
      if (empresa.site) doc.text(`Site: ${empresa.site}`, 45, 40);
    }

    doc.setFontSize(10);
    doc.text(`RELATÓRIO DE PRODUTOS VENDIDOS`, pageWidth / 2, 50, { align: "center" });
    doc.setFontSize(8);
    doc.text(`Data de emissão: ${getCurrentDateTime()}`, 10, 55);

    // Tabela
    doc.autoTable({
      head: [["Número", "Data Emissão", "Produto", "Preço", "Quantidade", "Total"]],
      body: data,
      startY: 60,
      styles: { fontSize: 8, cellPadding: 2 },
      columnStyles: {
        0: { cellWidth: 30 },
        1: { cellWidth: 30 },
        2: { cellWidth: 60 },
        3: { cellWidth: 25, halign: "right" },
        4: { cellWidth: 20, halign: "center" },
        5: { cellWidth: 25, halign: "right" },
      },
    });

    // Total geral
    const finalY = doc.lastAutoTable.finalY || 60;
    doc.setFontSize(10);
    doc.text("Total Geral:", pageWidth - 50, finalY + 10);
    doc.text(formatarValor(totalGeral), pageWidth - 10, finalY + 10, { align: "right" });

    return { doc, pageHeight };
  };

  useEffect(() => {
    const loadPDF = async () => {
      if (produtos.length === 0 || loading) return;
      try {
        let logoBase64;
        if (empresa?.img) {
          try {
            logoBase64 = await toBase64(empresa.img);
          } catch {
            logoBase64 = await toBase64(logo);
          }
        } else {
          logoBase64 = await toBase64(logo);
        }

        const { doc, pageHeight } = await generatePDF(logoBase64);
        const pdfUrl = doc.output("bloburl");

        if (pdfRef.current) {
          pdfRef.current.src = pdfUrl;
          setIframeHeight(pageHeight * 4 + "px");
        }
      } catch (error) {
        console.error("Erro ao gerar PDF:", error);
      }
    };

    loadPDF();
  }, [produtos, empresa, loading]);

if (loading) {
  const antIcon = <LoadingOutlined style={{ fontSize: 48, color: '#f98244' }} spin />;
  return (
    <div style={{ 
      display: "flex", 
      justifyContent: "center", 
      alignItems: "center", 
      height: "100vh", 
      flexDirection: "column", 
      gap: 16, 
      background: '#f8f9fa' 
    }}>
      <Spin indicator={antIcon} />
      <span style={{ fontSize: 18, color: '#333', fontWeight: 'bold' }}>
        Gerando relatório, aguarde...
      </span>
    </div>
  );
}

  return (
    <div style={{ width: "100%", height: "100vh", overflow: "auto" }}>
      <iframe
        ref={pdfRef}
        width="100%"
        height={iframeHeight}
        style={{ border: "none" }}
        title="Relatório Produtos Vendidos"
      />
    </div>
  );
};

export default RelatorioProdutosVendidos;
